import { render } from "./Erp.vue?vue&type=template&id=055a8c85&scoped=true"
import script from "./Erp.vue?vue&type=script&lang=js"
export * from "./Erp.vue?vue&type=script&lang=js"

import "./Erp.vue?vue&type=style&index=0&id=055a8c85&scoped=true&lang=css"

import exportComponent from "c:\\dev\\davca-cm\\davca-cm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-055a8c85"]])

export default __exports__